export default __webpack_public_path__ + "ubisoft-playtest-profile-mobile-steps-4-4.webp";